"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var ObjectId = require('bson').ObjectID;

var clone = require('clone');

var tv4 = require('tv4');

var RoomSuite = /*#__PURE__*/function () {
  function RoomSuite(opt) {
    _classCallCheck(this, RoomSuite);

    this._id = new ObjectId();
    this.name = null;
    this.campusCode = null;
    this.tenantCode = null;
    this.buildingId = null;
    this.buildingName = null;
    this.rooms = [];

    if (opt) {
      this.fillObject(clone(opt));
    }
  }

  _createClass(RoomSuite, [{
    key: "fillObject",
    value: function fillObject(opt) {
      var _this = this;

      this._id = new ObjectId(opt._id);
      this.name = opt.name || null;
      this.campusCode = opt.campusCode || null;
      this.tenantCode = opt.tenantCode || null;
      this.buildingId = opt.buildingId || null;
      this.buildingName = opt.buildingName || null;

      if (opt.rooms) {
        opt.rooms.forEach(function (room) {
          return _this.rooms.push(room);
        });
      }
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, RoomSuite.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'room-suite.schema.json',
        type: 'object',
        additionalProperties: false,
        properties: {
          _id: {
            type: ['object', 'null']
          },
          name: {
            type: ['string']
          },
          campusCode: {
            type: ['string']
          },
          tenantCode: {
            type: ['string']
          },
          buildingId: {
            type: ['string']
          },
          buildingName: {
            type: ['string']
          },
          rooms: {
            type: 'array',
            item: {
              type: 'object'
            }
          }
        },
        required: Object.keys(new RoomSuite())
      };
    }
  }]);

  return RoomSuite;
}();

module.exports = RoomSuite;